<template>
  <b-modal
    centered
    id="select-update-dialog"
    size="lg"
    modal-class="overflow-hidden"
    title=""
    static
    scrollable
    @hidden="onHidden"
    v-model="showModalUpdate"
    hide-footer
  >
    <div class="card p-10 pt-15" style="overflow-x: hidden; overflow-y: auto">
      <div class="card-header m-b-10">
        <div>
          <h6 class="text-center">Thông tin giao dịch của merchant</h6>
          <p class="text-center" v-if="search.dateTransactionFrom && search.dateTransactionTo">
            Thời gian: {{ search.dateTransactionFrom | formatDate }} -
            {{ search.dateTransactionTo | formatDate }}
          </p>
        </div>
        <div class="row p-10">
          <div class="col-md-8">
            <div style="display: flex">
              <p>Merchant Account:</p>
              <p class="ml-2">
                {{ detail && detail.merchantName ? detail.merchantName : '' }}<br />
                {{ detail && detail.merchantEmail ? detail.merchantEmail : '' }}<br />
                {{ detail.mcc ? joinArrayData(detail.mcc, dataConfigMcc) : '' }}<br />
              </p>
            </div>
            <div style="display: flex">
              <p>Nhân viên chăm sóc:</p>
              <p class="ml-2">
                {{ detail && detail.userCare && detail.userCare.name ? detail.userCare.name : ''
                }}<br />
                {{ detail && detail.userCare && detail.userCare.email ? detail.userCare.email : ''
                }}<br />
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div style="display: flex">
              <p>Loại Merchant:</p>
              <p class="ml-2">
                {{ detail && detail.level ? joinArrayData(detail.level, optionMerchantType) : '' }}
              </p>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="tab-content" id="nav-tabContent">
            <div class="p-10">
              <b-table-simple hover small caption-top responsive bordered>
                <caption></caption>
                <colgroup>
                  <col />
                  <col />
                </colgroup>
                <colgroup>
                  <col />
                  <col />
                  <col />
                </colgroup>
                <colgroup>
                  <col />
                  <col />
                </colgroup>
                <b-thead class="color-table">
                  <b-tr>
                    <b-th class="text-center">Loại giao dịch</b-th>
                    <b-th class="text-center table-th-width">TPV</b-th>
                    <b-th class="text-center table-th-width">TPV KPI</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody v-if="!isLoading && Object.keys(data).length > 0">
                  <b-tr>
                    <b-th rowspan="6">
                      <template v-for="transaction in displayTransactionType">
                        <span
                          style="margin-left: 20px"
                          v-if="
                            transaction.hasOwnProperty('parent') &&
                            !transaction.hasOwnProperty('parent_sub1')
                          "
                          ><b-icon icon="arrow-left-right" aria-hidden="true"></b-icon
                          ><span class="ml-2">{{ transaction.text }}</span></span
                        >
                        <span
                          class="text-muted"
                          style="margin-left: 35px"
                          v-if="
                            transaction.hasOwnProperty('parent') &&
                            transaction.hasOwnProperty('parent_sub1')
                          "
                          ><i
                            >•<span class="ml-2">{{ transaction.text }}</span></i
                          ></span
                        >
                        <span class="text-primary" v-if="!transaction.hasOwnProperty('parent')"
                          ><b-icon
                            icon="bar-chart-line"
                            aria-hidden="true"
                            variant="primary"
                          ></b-icon
                          ><span class="ml-2">{{ transaction.text }}</span></span
                        >
                        <br />
                      </template>
                    </b-th>
                    <b-td class="text-right">
                      <template v-for="transaction in displayTransactionType">
                        <template v-for="item in data['TRANSACTION']">
                          <span v-if="item.subTypeTransaction2 === transaction.id">{{
                            item.totalTpv | transformMoney
                          }}</span>
                          <br v-if="item.subTypeTransaction2 === transaction.id" />
                        </template>
                      </template>
                    </b-td>
                    <b-td class="text-right text-success">
                      <template v-for="transaction in displayTransactionType">
                        <template v-for="item in data['TRANSACTION']">
                          <span v-if="item.subTypeTransaction2 === transaction.id">{{
                            item.totalTpvKpi | transformMoney
                          }}</span>
                          <br v-if="item.subTypeTransaction2 === transaction.id" />
                        </template>
                      </template>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tfoot class="color-table" v-if="!isLoading && Object.keys(data).length > 0">
                  <b-tr>
                    <b-td class="text-left"> Tổng </b-td>
                    <b-td class="text-right">
                      <span
                        v-if="data['TOTAL_TRANSACTION'] && data['TOTAL_TRANSACTION'].totalTpv"
                        >{{ data['TOTAL_TRANSACTION'].totalTpv | transformMoney }}</span
                      >
                      <span v-else>0</span>
                    </b-td>
                    <b-td class="text-right text-success">
                      <span
                        v-if="data['TOTAL_TRANSACTION'] && data['TOTAL_TRANSACTION'].totalTpvKpi"
                        >{{ data['TOTAL_TRANSACTION'].totalTpvKpi | transformMoney }}</span
                      >
                      <span v-else>0</span>
                    </b-td>
                  </b-tr>
                </b-tfoot>
                <div class="text-center my-2" v-if="isLoading">
                  <b-spinner class="align-middle" />
                </div>
                <div
                  class="text-center text-info my-2"
                  v-if="!isLoading && Object.keys(data).length === 0"
                >
                  Không có dữ liệu
                </div>
              </b-table-simple>
            </div>
          </div>
        </div>
      </div>
    </div>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </b-modal>
</template>
<script>
  import Config from '@/thirdParty/config'
  import { detailTpvMcTransaction } from '@/services/customer-support/tpv'

  export default {
    props: {
      dataConfigMcc: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        Config,
        showModalUpdate: false,
        showLoading: false,
        isLoading: false,
        data: {},
        search: {
          page: 1,
          size: 20,
        },
        pagination: {
          total: 0,
        },
        optionMerchantType: [
          { id: 'MC_KEY', text: 'Merchant key' },
          { id: 'MC_NORMAL', text: 'Merchant thường' },
        ],
        displayTransactionType: [
          { id: 'MANUAL_PAYMENT', text: 'Thanh toán có hiện diện' },
          { id: 'MANUAL_PAYMENT_BANK', text: 'Thanh toán thẻ', parent: 'MANUAL_PAYMENT' },
          { id: 'MANUAL_PAYMENT_NFC', text: 'Thanh toán NFC', parent: 'MANUAL_PAYMENT' },
          {
            id: 'MANUAL_PAYMENT_NFC_AGS',
            text: 'NFC qua AGS',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_NFC',
          },
          {
            id: 'MANUAL_PAYMENT_NFC_BANK',
            text: 'NFC bằng thẻ',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_NFC',
          },
          { id: 'MANUAL_PAYMENT_QR', text: 'QR code', parent: 'MANUAL_PAYMENT' },
          {
            id: 'MANUAL_PAYMENT_QR_VIETQR',
            text: 'VIETQR',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_QR',
          },
          {
            id: 'MANUAL_PAYMENT_QR_CREDIT',
            text: 'QR thẻ tín dụng',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_QR',
          },
          {
            id: 'MANUAL_PAYMENT_QR_OTHER',
            text: 'QR khác',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_QR',
          },
          { id: 'ONLINE_PAYMENT', text: 'Thanh toán không hiện diện' },
          { id: 'ONLINE_PAYMENT_BANK', text: 'Thanh toán thẻ', parent: 'ONLINE_PAYMENT' },
          { id: 'ONLINE_PAYMENT_NFC', text: 'Thanh toán NFC', parent: 'ONLINE_PAYMENT' },
          { id: 'ONLINE_PAYMENT_QR', text: 'Qr code/khác', parent: 'ONLINE_PAYMENT' },
          { id: 'ONLINE_PAYMENT_PAYON', text: 'Tích hợp Payon', parent: 'ONLINE_PAYMENT' },
          { id: 'INSTALLMENT', text: 'Trả góp' },
          { id: 'BNPL', text: 'BNPL' },
          { id: 'MOTO', text: 'MOTO' },
          { id: 'LENDING_NEXTLEND', text: 'Nextlend' },
          { id: 'OTHER', text: 'OTHER' },
        ],
        detail: {},
      }
    },
    created() {},
    computed: {
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
    },
    methods: {
      async fetchData(id) {
        try {
          this.showLoading = true
          const bodySearch = { mcMposId: this.detail.merchantMposId }
          const exeception = ['page', 'size', 'limit']
          for (const key in this.search) {
            if (this.search[key] && this.search[key] !== '0' && !exeception.includes(key)) {
              bodySearch[key] = this.search[key]
            }
          }
          const response = await detailTpvMcTransaction(bodySearch)
          if (response.code === 1000 && response.data) {
            this.prepareDisplayData(response.data)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      onHidden() {
        this.showModalUpdate = false
        this.resetForm()
      },
      resetForm() {
        this.data = {}
        this.detail = {}
      },
      show(item, filter) {
        this.resetForm()
        this.showModalUpdate = true
        this.detail = item
        this.search = filter
        this.fetchData(item.id)
      },
      prepareDisplayData(data) {
        const totalTransaction = {}

        this.data = data.reduce((acc, current) => {
          if (!acc.TRANSACTION) {
            acc.TRANSACTION = []
          }

          acc.TRANSACTION.push(current)

          if (!totalTransaction[current.typeTransaction]) {
            totalTransaction[current.typeTransaction] = {
              totalTpv: 0,
              totalTpvKpi: 0,
              typeTransaction: '',
            }
          }

          totalTransaction[current.typeTransaction].totalTpv += current.totalTpv
          totalTransaction[current.typeTransaction].totalTpvKpi += current.totalTpvKpi
          totalTransaction[current.typeTransaction].typeTransaction = current.typeTransaction

          return acc
        }, {})

        this.data.TOTAL_TRANSACTION = {
          totalTpv: 0,
          totalTpvKpi: 0,
        }

        for (const key in totalTransaction) {
          this.data.TOTAL_TRANSACTION.totalTpv += totalTransaction[key].totalTpv
          this.data.TOTAL_TRANSACTION.totalTpvKpi += totalTransaction[key].totalTpvKpi
        }

        if (Object.keys(this.data).length > 0) {
          const checkData = this.data.TRANSACTION.map(tx => tx.subTypeTransaction2)
          for (let i = 0; i < this.displayTransactionType.length; i++) {
            if (!checkData.includes(this.displayTransactionType[i].id)) {
              this.data.TRANSACTION.push({
                typeTransaction: this.displayTransactionType[i].id,
                subTypeTransaction1: this.displayTransactionType[i].id,
                subTypeTransaction2: this.displayTransactionType[i].id,
                totalTpv: 0,
                totalLendingTpv: 0,
                totalTpvKpi: 0,
              })
            }
          }

          // total transaction following group
          const totalPaymentOnline = { totalTpv: 0, totalTpvKpi: 0 }
          const totalPaymentManual = { totalTpv: 0, totalTpvKpi: 0 }
          const totalPaymentManualQR = { totalTpv: 0, totalTpvKpi: 0 }
          const totalPaymentManualNFC = { totalTpv: 0, totalTpvKpi: 0 }

          for (let j = 0; j < this.data.TRANSACTION.length; j++) {
            if (this.data.TRANSACTION[j].typeTransaction === 'ONLINE_PAYMENT') {
              totalPaymentOnline.totalTpv += this.data.TRANSACTION[j].totalTpv
              totalPaymentOnline.totalTpvKpi += this.data.TRANSACTION[j].totalTpvKpi
            }
            if (this.data.TRANSACTION[j].subTypeTransaction1 === 'MANUAL_PAYMENT_QR') {
              totalPaymentManualQR.totalTpv += this.data.TRANSACTION[j].totalTpv
              totalPaymentManualQR.totalTpvKpi += this.data.TRANSACTION[j].totalTpvKpi
            }
            if (this.data.TRANSACTION[j].subTypeTransaction1 === 'MANUAL_PAYMENT_NFC') {
              totalPaymentManualNFC.totalTpv += this.data.TRANSACTION[j].totalTpv
              totalPaymentManualNFC.totalTpvKpi += this.data.TRANSACTION[j].totalTpvKpi
            }
            if (
              this.data.TRANSACTION[j].typeTransaction === 'MANUAL_PAYMENT' &&
              this.data.TRANSACTION[j].subTypeTransaction1 !== 'MANUAL_PAYMENT_QR' &&
              this.data.TRANSACTION[j].subTypeTransaction1 !== 'MANUAL_PAYMENT_NFC'
            ) {
              totalPaymentManual.totalTpv += this.data.TRANSACTION[j].totalTpv
              totalPaymentManual.totalTpvKpi += this.data.TRANSACTION[j].totalTpvKpi
            }
          }

          const indexPaymentOnline = this.data.TRANSACTION.findIndex(
            item => item.subTypeTransaction2 === 'ONLINE_PAYMENT'
          )
          if (indexPaymentOnline !== -1) {
            this.$set(this.data.TRANSACTION, indexPaymentOnline, {
              ...this.data.TRANSACTION[indexPaymentOnline],
              totalTpv: totalPaymentOnline.totalTpv,
              totalTpvKpi: totalPaymentOnline.totalTpvKpi,
            })
          }
          const indexPaymentManualQr = this.data.TRANSACTION.findIndex(
            item => item.subTypeTransaction2 === 'MANUAL_PAYMENT_QR'
          )
          if (indexPaymentManualQr !== -1) {
            this.$set(this.data.TRANSACTION, indexPaymentManualQr, {
              ...this.data.TRANSACTION[indexPaymentManualQr],
              totalTpv: totalPaymentManualQR.totalTpv,
              totalTpvKpi: totalPaymentManualQR.totalTpvKpi,
            })
          }
          const indexPaymentManualNfc = this.data.TRANSACTION.findIndex(
            item => item.subTypeTransaction2 === 'MANUAL_PAYMENT_NFC'
          )
          if (indexPaymentManualNfc !== -1) {
            this.$set(this.data.TRANSACTION, indexPaymentManualNfc, {
              ...this.data.TRANSACTION[indexPaymentManualNfc],
              totalTpv: totalPaymentManualNFC.totalTpv,
              totalTpvKpi: totalPaymentManualNFC.totalTpvKpi,
            })
          }
          const indexPaymentManual = this.data.TRANSACTION.findIndex(
            item => item.subTypeTransaction2 === 'MANUAL_PAYMENT'
          )
          if (indexPaymentManual !== -1) {
            this.$set(this.data.TRANSACTION, indexPaymentManual, {
              ...this.data.TRANSACTION[indexPaymentManual],
              totalTpv:
                totalPaymentManual.totalTpv +
                totalPaymentManualQR.totalTpv +
                totalPaymentManualNFC.totalTpv,
              totalTpvKpi:
                totalPaymentManual.totalTpvKpi +
                totalPaymentManualQR.totalTpvKpi +
                totalPaymentManualNFC.totalTpvKpi,
            })
          }
        }
      },
    },
  }
</script>
<style scoped>
  .color-table {
    color: #212529;
    background-color: rgba(0, 0, 0, 0.03);
  }
  .table-th-width {
    min-width: 100px;
    max-width: 100px;
  }
</style>
